import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import DatePickerInputV1 from "../../inputs/date-time/v1";
import libForm from "../../../util/libForm";
import SelectInput from "../../inputs/select";
import LibDateTime from "../../../util/libDateTime";
import NumberInput from "../../inputs/number";
import { BtnCustom } from "../../button/button";
import TableInstallment from "../generate-installments";
import HeaderRegister from "../../header/register";
import { repeetInstallment, daysOfMonth } from "../data/data";
import { schema } from "./schema";
import { ContextGlobal } from "../../../context";
import ModalMain from "../../modal";

const Installment = ({ installmentValue, CallBackInstallments, hideSubmit = false }) => {
	const { formPaymentData, bankData, fetchFormPayment } = useContext(ContextGlobal);

	useEffect(() => {
		if (formPaymentData.length === 0) fetchFormPayment();
	}, []);

	const {
		control,
		handleSubmit,
		register,
		setValue,
		watch,
		formState: { errors, isSubmitting },
	} = useForm({
		resolver: zodResolver(schema),
		defaultValues: {
			id_forma: 1,
			id_conta: 1,
			id_tipo_repeticao: 30,
			qtde_parcelas: 1,
			valor_total: installmentValue,
			primeiro_lancamento: new Date(),
			cobrar_dia: LibDateTime.dayOfMonth(new Date()),
			active: false,
		},
	});

	const [installmentSetup, setInstallmentSetup] = useState({});
	const id_tipo_repeticao = watch("id_tipo_repeticao");
	const id_forma = watch("id_forma");

	// Dinheiro, Pix, Débito e Crédito nascem pagos com data de hoje (mesmo padrão do
	// close-sale-modal) — só o Vale mantém data manual e nasce pendente.
	useEffect(() => {
		if ([1, 3, 4, 5].includes(Number(id_forma))) {
			setValue("primeiro_lancamento", new Date());
			setValue("id_tipo_repeticao", 30); // Reset for consistency, though it will be ignored on generate
		}
	}, [id_forma, setValue]);

	const isAutoDate = [1, 3, 4, 5].includes(Number(id_forma));

	const handleOnSubmit = (data) => {
		setInstallmentSetup(data);
	};

	return (
		<>
			<div>
				<HeaderRegister title="Parcelas" />
				<span className="d-block text-sm">Valor total</span>
				<strong>{Number(installmentValue).toFixed(2)}</strong>
			</div>
			<div className="flex-1 overflow-y-auto overflow-x-hidden">
				<form className="mt-3 border-bottom" onSubmit={handleSubmit(handleOnSubmit)}>
					<div className="row items-center">
						<NumberInput
							label="Qtde. Parcelas"
							name="qtde_parcelas"
							control={control}
							errors={errors}
							className="col-4 col-sm-4 col-lg-2"
							onKeyDown={libForm.EnterTab}
							autoFocus={true}
						/>

						{!isAutoDate && (
							<SelectInput
								className="col-10"
								label="Configuração de repetição"
								id="id_tipo_repeticao"
								labelSelect="description"
								control={control}
								errors={errors}
								data={repeetInstallment}
								setValue={setValue}
								onKeyDown={libForm.EnterTab}
								// loading={loadingCities}
							/>
						)}

						<SelectInput
							className="col-12 col-sm-6 col-lg-3"
							label="Forma Pagamento"
							id="id_forma"
							labelSelect="nome"
							control={control}
							errors={errors}
							data={formPaymentData}
							setValue={setValue}
							onKeyDown={libForm.EnterTab}
							// loading={loadingCities}
						/>
						{id_tipo_repeticao === 30 && !isAutoDate && (
							<SelectInput
								className="col-12 col-sm-6 col-lg-3"
								label="Cobrar sempre no"
								id="cobrar_dia"
								labelSelect="description"
								control={control}
								errors={errors}
								data={daysOfMonth}
								setValue={setValue}
								onKeyDown={libForm.EnterTab}
								// loading={loadingCities}
							/>
						)}
						{!isAutoDate && (
							<DatePickerInputV1
								label="1º Lançamento"
								id="primeiro_lancamento"
								register={register}
								control={control}
								errors={errors}
								showTime={false}
								onKeyDown={libForm.EnterTab}
								className="col-12 col-sm-6 col-lg-3"
							/>
						)}

						<SelectInput
							label="Conta de recebimento"
							id="id_conta"
							labelSelect="banco"
							control={control}
							errors={errors}
							data={bankData}
							setValue={setValue}
							onKeyDown={libForm.EnterTab}
							// handleSelect={handleSelectedState}
							// loading={loadingCities}
							className="col-12 col-sm-6 col-lg-4"
						/>

						<div className="flex justify-end mt-1">
							<button className="btn btn-sm btn-primary mb-3" isSubmitting={isSubmitting}>
								Gerar Parcelas
							</button>
						</div>
					</div>
				</form>

				{formPaymentData?.length > 0 && (
					<div className="mt-4">
						<TableInstallment
							installmentSetup={installmentSetup}
							formaPgtoData={formPaymentData}
							CallBackInstallments={CallBackInstallments}
							hideSubmit={hideSubmit}
						/>
					</div>
				)}
			</div>
		</>
	);
};

export default Installment;

{
	/* <div className="input-box col-2">
						<label htmlFor="active" className="text-secondary text-sm">
							Repetir Lançamento
						</label>

						<Controller
							name="active"
							control={control}
							defaultValue={true}
							render={({ field }) => (
								<Switch
									checked={field.value}
									onChange={(e) => field.onChange(e.target.checked)}
									// inputProps={{
									// 	"aria-label": "Clientes Ativos",
									// }}
								/>
							)}
						/>

						{errors.active && <p className="errors">{errors.active.message}</p>}
					</div> */
}
{
	/* {repetirLancamento && qtde_parcelas > 1 && ( */
}

// const handleGenerateInstallments = (data) => {
// 	const newInstallments = [];

// 	const { primeiro_lancamento, cobrar_dia, id_forma, qtde_parcelas, id_tipo_repeticao } = data;
// 	const installmentAmount = Number(installmentValue.replace(",", ".")) / qtde_parcelas;

// 	const repetitionDays = id_tipo_repeticao;

// 	for (let i = 0; i < qtde_parcelas; i++) {
// 		const dueDate = new Date(primeiro_lancamento);

// 		if (i > 0) {
// 			if (id_tipo_repeticao === 30) {
// 				dueDate.setMonth(dueDate.getMonth() + i);

// 				const adjustedDay = Math.min(
// 					cobrar_dia,
// 					new Date(dueDate.getFullYear(), dueDate.getMonth() + 1, 0).getDate()
// 				);
// 				dueDate.setDate(adjustedDay);
// 			} else {
// 				dueDate.setDate(dueDate.getDate() + i * repetitionDays);
// 			}
// 		}

// 		newInstallments.push({
// 			dueDate,
// 			paymentMethod: formaPgtoData.find((forma) => forma.id_forma === id_forma).nome,
// 			amount: installmentAmount,
// 			status: false, // default status as unpaid
// 		});
// 	}

// 	setGeneratedInstallments(newInstallments);
// };

// const handleToggleStatus = (index) => {
// 	setGeneratedInstallments((prevInstallments) =>
// 		prevInstallments.map((installment, i) =>
// 			i === index ? { ...installment, status: !installment.status } : installment
// 		)
// 	);
// };

// const handleEditInstallment = (index, field, value) => {
// 	setGeneratedInstallments((prevInstallments) =>
// 		prevInstallments.map((installment, i) => (i === index ? { ...installment, [field]: value } : installment))
// 	);
// };

// useEffect(() => {
// 	if (!repetirLancamento) {
// 		setValue("qtde_parcelas", 1);
// 		setGeneratedInstallments([]);
// 		setValue("cobrar_dia", LibDateTime.dayOfMonth(new Date()));
// 	}
// }, [repetirLancamento]);
